// import region ,react
import React from 'react';
import { useTable } from 'react-table';

// icons
import { IoMdMore } from "react-icons/io";
//end region

const BookingTable = ({ columns, data, dataStatus, showMore, handleClick }) => {


    // useTable hooks 
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });
    return (
        <table {...getTableProps()} style={{ width: '100%', marginLeft: 8 }}>

            {/* column headers */}
            <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th
                                style={{ borderBottomWidth: '1px', borderBottomColor: '#F2F2F2', borderBottomStyle: 'solid' }}
                                {...column.getHeaderProps()}
                            >
                                <div style={{ marginTop: 14 }}>
                                    {column.render("Header")}
                                </div>
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>

            {/* body */}
            <tbody {...getTableBodyProps()}>
                {
                    dataStatus == 'loading' ? null :
                        rows.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr
                                    {...row.getRowProps()}
                                    style={{
                                        borderBottomWidth: '1px',
                                        borderBottomColor: '#F2F2F2',
                                        borderBottomStyle: 'solid',
                                        fontSize: 12,
                                    }}
                                >
                                    {row.cells.map(cell => {
                                        return <td style={{ padding: 12 }} {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                    })}
                                    {showMore &&
                                        <td>
                                            <IoMdMore size={18} style={{ cursor: 'pointer' }} onClick={() => { handleClick(i) }} />
                                        </td>
                                    }
                                </tr>
                            );
                        })
                }
            </tbody>
        </table>
    );
}


export default BookingTable;
